import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_HISTORY_LOG: createAsyncActionConstants('FETCH_HISTORY_LOG'),
    FETCH_HISTORY_CV_LOG: createAsyncActionConstants('FETCH_HISTORY_CV_LOG'),
    FETCH_HISTORY_BLOB: createAsyncActionConstants('FETCH_HISTORY_BLOB'),
	FETCH_OUTPUT_FILE: createAsyncActionConstants('FETCH_OUTPUT_FILE')
}